/**
 * Checkout rules for Guardian personal plans.
 * Freemium has no trial. Paid self-serve plans offer a 1-week trial at
 * payment-method signup. Annual + trial = monthly x 11.75; otherwise x 11.5.
 */
import {
  annualCentsFromMonthly,
  annualTrialCentsFromMonthly,
} from './guardianPlans';

export const SELF_SERVE_PLAN_IDS = new Set(['citizen', 'researcher', 'pro']);

export function canChoosePaidPlan(planId, liveSub) {
  return !liveSub && SELF_SERVE_PLAN_IDS.has(planId);
}

export function buildCheckoutRequest({
  planSlug,
  period = 'monthly',
  startTrial = false,
}) {
  return {
    planSlug,
    period,
    startTrial: Boolean(startTrial),
  };
}

export function annualCheckoutAmounts(monthlyCents, annualCents) {
  if (!monthlyCents || monthlyCents <= 0) {
    return { noTrialCents: 0, trialCents: 0 };
  }
  return {
    noTrialCents: annualCents || annualCentsFromMonthly(monthlyCents),
    trialCents: annualTrialCentsFromMonthly(monthlyCents),
  };
}
